import { render, staticRenderFns } from "./SocialsDisplay.vue?vue&type=template&id=2ba213fa&scoped=true&"
import script from "./SocialsDisplay.vue?vue&type=script&lang=ts&"
export * from "./SocialsDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SocialsDisplay.vue?vue&type=style&index=0&id=2ba213fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba213fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
